import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cctcwhna9r: FaireBrandEntity = {
  token: "b_cctcwhna9r",
  type: "brand",
  name: "My Curl products",
  avatarUrl:
    "https://cdn.faire.com/fastly/37cf9251d14167661ca1aef2024a5ceb8a93e8083d17dc0d8f2f8d3d0cdab0ab.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c8eac5f3fa83029e56b71c7acecfb001507e7fbcc5ab772c17d71bd6e25a928e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/37cf9251d14167661ca1aef2024a5ceb8a93e8083d17dc0d8f2f8d3d0cdab0ab.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c8eac5f3fa83029e56b71c7acecfb001507e7fbcc5ab772c17d71bd6e25a928e.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 3,
  isInsider: true,
  description:
    "My Curl products is where professional hair care meets true expertise. Founded by Lisa Fuller—a licensed cosmetologist, celebrity stylist, and salon owner with over 20 years of experience—our premium line was created with the needs of professional stylists in mind. Each product is thoughtfully crafted to deliver performance, quality, and results you can trust. With My Curl, you’re not just using products—you’re working with formulas designed by a stylist for stylists, to help you elevate every look and every client’s experience.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:31.090Z",
    importedBy: "entity-db-cli",
  },
};
